export default __webpack_public_path__ + "static/media/redacted.28748a45.png";